import React from "react";
import { FooterProps } from "./Footer.types";
import { getClassName } from "../../helpers/common.helpers";
import "./FooterComponent.scss";

const footerDefaultLeftContentUI = <div>Copyright © {new Date().getFullYear()} cPaperless LLC</div>;
const footerDefaultRightContentUI = <div><a href="https://safesend.com/legal-policies/terms-of-use.php" target="_blank">Terms of service</a><span className="separator">-</span><a href="https://safesend.com/legal-policies/privacy-statement.php" target="_blank">Privacy Policy</a></div>


const FooterComponent = ({ footerClassname, footerLeftContent = footerDefaultLeftContentUI, footerLeftContentClassName, footerRightContent = footerDefaultRightContentUI, footerRightContentClassName }: FooterProps) => {
    return <div className={getClassName("footer", footerClassname ?? "")} >
        <div className={getClassName("footer__leftcontainer", footerLeftContentClassName ?? "")}>{footerLeftContent}</div>

        <div className={getClassName("footer__rightcontainer", footerRightContentClassName ?? "")}>{footerRightContent}</div>
    </div>
}

export default FooterComponent;